/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import { getUnreadMessages, getUnreadNotifications } from "../../../../services/apiservices/timesheets";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CircularProgress from "@mui/material/CircularProgress";
import ActionRender from "../../ActionRender";
import AuthContext from "../../../../hooks/authContext";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import { Label } from "../../../../components/ui/label";
import { Download, FileSpreadsheet, FileText, Filter, Mail, MessageCircle } from "lucide-react";
import { getCompanyEmployees } from "../../../../services/apiservices/employee";
import ThemeTable from "../../../../components/Table/ThemeTable";
import EmailReports from "../../EmailReports";
import { CSVLink } from "react-csv";
import { MobileUnReadMessage } from "../MobileViewReports";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../../components/ui/tooltip";
import { Badge } from "../../../../components/ui/badge";
import { getSettings } from "../../../../services/apiservices/settings";


function UnReadMessage(props) {

  const csvHeaders = [
    "Employee",
    "Received",
    "UnRead",
    "UnRead Rate (%)",
    "Type",
   "Oldest Date",
    "Avg. Time to Read",
  ];

  const [employeeList, setEmployeeList] = useState([]);
  const [employeeListMaster, setEmployeeListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [empName, setEmpName] = useState("All");
  const [employee, setEmployee] = useState();
  const [settingsData, setSettingsData] = useState();
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [loader, setLoader] = useState(false);
  const [empNameList, setEmpNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const { setReportData } = auth || {};
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

  const getColumns = () => {
    const columns = [
      {
        id: "employeeName",
        numeric: false,
        disablePadding: false,
        label: "Employee",
        isSortable: false,
        gray: true,
      },
      {
        id: "received",
        numeric: false,
        disablePadding: false,
        label: "Received",
        isSortable: false,
        gray: true,
      },
      {
        id: "unread",
        numeric: false,
        disablePadding: false,
        label: "UnRead",
        isSortable: false,
        gray: true,
      },
      {
        id: "rate",
        numeric: false,
        disablePadding: false,
        label: "UnRead Rate (%)",
        isSortable: false,
        gray: true,
      },
      {
        id: "type",
        numeric: false,
        disablePadding: false,
        label: "Type",
        isSortable: false,
        gray: true,
      },
      {
        id: "oldestDate",
        numeric: false,
        disablePadding: false,
        label: "Oldest Date",
        isSortable: false,
        gray: true,
      },
      {
        id: "avgtime",
        numeric: false,
        disablePadding: false,
        label: "Avg. Time to Read",
        isSortable: false,
        gray: true,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
        gray: true,
      },
    ];

    if (isMobile || isLandscape) {
      return columns.filter(col => col.id !== "employeeName" && col.id !== "appointmentDate" && col.id !== "Action");
    }

    return columns;
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = employeeList?.filter(
        (item) => item.employeNameId === rcellItem.employeNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.employeeName,
          item?.received,
          item?.unread,
          item?.rate,
          item?.type,
          item?.oldestDate,
          item?.avgtime,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.employeeName,
          item?.received,
          item?.unread,
          item?.rate,
          item?.type,
          item?.oldestDate,
          item?.avgtime,
        ];
      });
    }
    return clientCSV;
  }

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
      employeeList?.filter(
        (item) => item.employeNameId === rcellItem.employeNameId
      );
      return [
        rcellItem?.employeeName,
        rcellItem?.received,
        rcellItem?.unread,
        rcellItem?.rate,
        rcellItem?.type,
        rcellItem?.oldestDate,
        rcellItem?.avgtime,
      ];
    } else {
      return [
        rcellItem?.employeeName,
        rcellItem?.received,
        rcellItem?.unread,
        rcellItem?.rate,
        rcellItem?.type,
        rcellItem?.oldestDate,
        rcellItem?.avgtime,
      ];
    }
  }

   useEffect(() => {
     const getEmployeesData = async () => {
       const [employeeRes, settingsRes] = await Promise.all([
         new Promise((resolve, reject) => {
           getCompanyEmployees(
             companyId,
             (res) => resolve(res),
             (err) => resolve({ status: false, data: [] })
           );
         }),
         new Promise((resolve) =>
           getSettings("client_settings", companyId, (res) => resolve(res?.data))
         ),
       ]);
       const details = employeeRes?.data;
       const employee = details?.map((item) => {
         return {
           value: item?.id,
           label: `${item?.firstName} ${item?.lastName}`,
         };
       });
       const filteredData = settingsRes?.filter(
         (item) => !item.deleted
       );
       setSettingsData(filteredData?.length ? filteredData : []);
       setEmployee(details);
       setEmpNameList([{ label: "All", value: "All" }, ...employee]);
     };
     getEmployeesData();
   }, []);

  const downloadForExcel = async (rcellItem, emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Unread Messages Report');
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
    let fileName;
    if (rcellItem?.records) {
      fileName = `UnreadMessagesReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `UnreadMessagesReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    let name = true;
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
  }

  const downloadForPDF = async (rcellItem, emailSend) => {
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
    let fileName;
    if (Array.isArray(rcellItem?.records)) {
      fileName = `UnreadMessagesReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `UnreadMessagesReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    let name = true;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
  }

  const setDownloadCSVData = (event, done, rcellItem) => {
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);

    const reportName = "Unread Messages Report";
    const employeName = Array.isArray(rcellItem) ? `${rcellItem?.records?.[0]?.employeeName}` : `${rcellItem?.employeeName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

    // Create the report details rows
    const reportDetails = [
      [`Employee Name: ${employeName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
    let empNamefordwonLoad = 'All'

    if (empName !== 'All') {
      empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
    }

    const reportName = "Unread Messages Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

    const reportDetails = [
      [`Employee Name: ${empNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    setClientListCSV(reportDetails);
    done();
  };

  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
    let empNamefordwonLoad = 'All'

    if (empName !== 'All') {
      empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
    }
    let fileName = `UnReadMessagesReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    let name = true;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
  }

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Unread Messages Report');
    let empNamefordwonLoad = 'All'

    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));

    if (empName !== 'All') {
      empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
    }
    let fileName = `UnreadMessagesReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    let name = true;
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
  }


  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    let name;
    if (Array.isArray(rcellItem?.records)) {
      name = rcellItem?.records?.[0]?.employeeName;
    } else {
      name = rcellItem?.employeeName;
    }

    const [excelBlob, pdfBlob] = await Promise.all([
      downloadForExcel(rcellItem, emailSend),
      downloadForPDF(rcellItem, emailSend),
    ]);
    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "Unread Messages Report",
        ReportsName: "Employee Report",
        Name: name,
        Date: startDate,
        EndDate: endDate,
        pdf: pdfBlob,
        storedData: base64Data,
        fullData: "",
        fullExcelData: "",
      }));
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let empNamefordwonLoad = "All";

    if (empName !== "All") {
      empNamefordwonLoad = empNameList.filter(
        (item) => item.value === empName
      )[0].label;
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend),
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "Unread Messages Report",
        ReportsName: "Employee Report",
        Name: empNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: "",
      }));
      setOpenEmailDialog(true);
    };
  };

  const handleEmpNameChange = (e) => {

    const str = e;

    setEmpName(str);
    if (str === "All") {
      setEmployeeList(employeeListMaster);
    } else {
      setEmployeeList(() =>
        employeeListMaster?.filter((itme) => {
          let returnFlg = true;
          if (returnFlg) {
            returnFlg = str.includes(itme?.employeNameId);
          }
          return returnFlg;
        })
      );
    }
  };


  const handleGenerateReport = async () => {
    setLoader(true);
    let paramStartDate = "";
    let paramEndDate = "";

    paramStartDate = startDate;
    paramEndDate = endDate;
    getReportListData(paramStartDate, paramEndDate);
  }

  const mapWidhtEmpList = async (timeSheet, notifications = []) => {
    const toDate = (ts) =>
      ts?.seconds ? new Date(ts.seconds * 1000 + Math.floor(ts.nanoseconds / 1000000))
        : ts ? new Date(ts) : null;

    const findEmployee = (item) => {
            const empById = item?.userId ? employee?.find(e => e?.userId === item?.userId) : null;
            if (empById) return empById;
 
            if (item?.email) {
                const emails = Array.isArray(item?.email) ? item?.email : [item?.email];
                return employee?.find(e => emails?.includes(e?.email)) || null;
            }
 
            return { userId: "unknown", email: "unknown", firstName: "Unknown", lastName: "Unknown" };
        };

    const grouped = {};
    const unreadData = [];

    timeSheet?.forEach((item) => {
      const emp = findEmployee(item);
      const type = item?.type || "unknown";
      const key = `${emp?.userId}_${type}`;

      if (!grouped[key]) {
        grouped[key] = {
          employeNameId: emp?.userId,
          employeeName: `${emp?.firstName || ""} ${emp?.lastName || ""}`.trim(),
          employeeEmail: emp?.email || "",
          type,
          records: [],
          unreadRecords: [],
        };
      }

      grouped[key]?.records?.push(item);

      if (!item.open) {
        grouped[key]?.unreadRecords?.push(item);
        unreadData?.push(item);
      }
    });
  const demo = timeSheet?.filter(r => r?.type === "email");
    notifications?.forEach((notif) => {
      notif?.Employee?.forEach((notifEmp) => {
        const emp = findEmployee({ userId: notifEmp?.id, email: notifEmp?.email });

        if (!emp || emp?.userId === "unknown") {
          return;
        }

        const key = `${emp.userId}_notifications`;

        if (!grouped[key]) {
          grouped[key] = {
            employeNameId: emp.userId,
            employeeName: `${emp.firstName || ""} ${emp.lastName || ""}`.trim(),
            employeeEmail: emp.email || "",
            type: "notifications",
            records: [],
            unreadRecords: [],
          };
        }
    

        const record = {
          ...notif,
          createdAt: notif?.createdOn,
          openedOn: notif?.readUsers?.includes(emp?.email) ? notif.createdOn : null,
          open: notif?.readUsers?.includes(emp?.email) || false,
        };

        grouped[key].records.push(record);

        if (!record.open) {
          grouped[key].unreadRecords.push(record);
          unreadData.push(record);
        }
      });
    });


    const results = Object.values(grouped)?.map(grp => {
      const received = grp?.records?.length;
      const openCount = grp?.records?.filter(r => r?.open)?.length;
      const unread = received - openCount;

      const totalTime = grp?.records?.reduce((acc, r) => {
        if (r?.createdAt) {
          if (r?.open && r?.openedOn) {
            const diff = toDate(r.openedOn) - toDate(r.createdAt);
            return diff > 0 ? acc + diff : acc;
          } else {
            return acc + 0;
          }
        }
        return acc;
      }, 0);

      const validCount = grp.records.filter(r => r.open && r.createdAt && r.openedOn && (toDate(r.openedOn) - toDate(r.createdAt)) > 0).length;

      const avgOpenTime = validCount > 0 ? (() => {
        const hours = totalTime / validCount / 1000 / 60 / 60;
        return hours >= 1 ? hours.toFixed(1) + "h" : Math.round(hours * 60) + " min";
      })() : "0h";

      const openRate = received > 0 ? ((unread / received) * 100).toFixed(2) : "0.00";
      let oldestFormatted = null;
      if (grp?.records?.length > 0) {
        const allDates = grp?.records
          ?.map(r => toDate(r?.createdAt))
          ?.filter(Boolean);

        if (allDates?.length > 0) {
          const oldest = new Date(Math.min(...allDates?.map(d => d.getTime())));
          oldestFormatted = moment(oldest).format("MM-DD-YYYY");
        }
      }
      return {
        employeNameId: grp?.employeNameId,
        employeeName: grp?.employeeName,
        employeeEmail: grp?.employeeEmail,
        type: grp?.type,
        received,
        open: openCount,
        unread,
        rate: `${parseFloat(openRate)}%`,
        avgtime: avgOpenTime,
        openRate: openRate,
        oldestDate: oldestFormatted,
        unreadRecords: grp.unreadRecords,
      };
    });


    const sortedData = sortingFunction(results);
    setEmployeeListMaster(sortedData);
    setEmployeeList(() =>
      sortedData?.filter((itme) => {
        let returnFlg = true;
        if (empName !== "All" && returnFlg) {
          returnFlg = itme.employeNameId === empName;
        }
        return returnFlg;
      })
    );
    setLoader(false);
  };

  const sortingFunction = (data) => {
    const result = data?.sort((a, b) => {
      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      if (a.appointmentDateTime < b.appointmentDateTime) return -1;
      if (a.appointmentDateTime > b.appointmentDateTime) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`,
    };

    try {
      const [notifications, messages] = await Promise.all([
        new Promise((resolve, reject) =>
          getUnreadNotifications(param, resolve, reject)
        ),
        new Promise((resolve, reject) =>
          getUnreadMessages(param, resolve, reject)
        )
      ]);

      mapWidhtEmpList(messages, notifications);

    } catch (err) {
      console.error("Error fetching report data:", err);
    }
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "employeeName":
        if (
          rowindex !== 0 &&
          employeeList[rowindex - 1].employeeName !== rcellItem.employeeName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "rate":
        return (
          <Badge variant={parseFloat(rcellItem?.openRate) > 25 ? "destructive" : parseFloat(rcellItem?.openRate) > 15 ? "secondary" : "outline"} className="text-sm">
            {rcellItem?.rate}
          </Badge>
        )
      case "type":
        return (
          <Badge variant="outline">{rcellItem?.type}</Badge>
        )
      case "unread":
        return (
          <Tooltip>
            <TooltipTrigger asChild>
              <p className="text-xl font-semibold mt-4 cursor-pointer underline decoration-dotted text-destructive">
                {rcellItem?.unread}
              </p>
            </TooltipTrigger>
            <TooltipContent>
              <div className="max-w-80">
                <p className="font-semibold mb-8">Unread Messages:</p>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {rcellItem?.unreadRecords?.map((msg) => {
                    const ts = msg?.createdOn
                      ? moment(msg.createdOn)
                      : msg?.createdAt
                        ? moment(msg.createdAt.seconds * 1000 + Math.floor(msg.createdAt.nanoseconds / 1000000))
                        : null;

                    const formattedTs = ts ? ts.format("YYYY-MM-DD hh:mm A") : "N/A";

                    return (
                      <div key={msg?.id} className="p-8 bg-muted rounded text-sm">
                        <p className="font-medium">{msg?.subject}</p>
                        <p className="text-xs text-muted-foreground mt-4">
                          {rcellItem?.type} - {formattedTs}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </TooltipContent>
          </Tooltip>
        );
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UnreadMessagesReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            employeeList[rowindex - 1].employeNameId !== rcellItem.employeNameId
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UnreadMessagesReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UnreadMessagesReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]}</div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!employeeList?.length) return [];

    return employeeList?.reduce((acc, item) => {
      const employeeName = item?.employeeName;
    const record = {
        employeeName: item?.employeeName,
        received: item?.received,
        unread: item?.unread,
        rate: item?.rate,
        openRate: item?.openRate,
        type: item?.type,
        oldestDate: item?.oldestDate,
        avgtime: item?.avgtime,
      };

      const existingGroup = acc?.find((g) => g?.employeeName === employeeName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          employeeName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [employeeList]);

  const filteredEmployee = employee?.find((item) => item?.id === empName);

  const handleEmailDialogClose = async () => {
    setOpenEmailDialog(false);
    await handleGenerateReport();
  }

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Unread Messages Reports"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Reports" },
            { label: "New Reports" },
            { label: "Employee Reports", to: "/reports/newreport/employeereport" },
          ]}
          BreadCrumbCurrentPageTitle={"Unread Messages Reports"}
          showLastSeen={true}
        ></PageTitle>

        <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
          <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
            <div className="space-y-6">
              <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                <CardHeader className="pb-12">
                  <div className="flex items-center space-x-2">
                    <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                    <CardTitle className="text-lg sm:text-xl">
                      Report Parameters
                    </CardTitle>
                  </div>
                  <CardDescription className="text-left text-sm sm:text-base">
                    Configure the parameters for your unread message report
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {/* Employee Select */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="employee"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Employee Name *
                      </Label>
                      <SingleSelectNew
                        value={empName}
                        name="employeeName"
                        label="Employee Name"
                        onChange={(e) => handleEmpNameChange(e)}
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        options={empNameList}
                        className="w-full min-h-[40px] px-3 py-2"
                      />
                    </div>

                    {/* Start Date */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="startDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Start Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={startDate}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                            // if (newValue) {
                            //   setEndDate(moment());
                            // } else {
                            //   setEndDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* End Date */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="endDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        End Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={endDate}
                          onChange={(newValue) => {
                            setEndDate(newValue);
                            // if (!newValue) {
                            //   setStartDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="flex justify-start sm:justify-end pt-8">
                    <Button
                      type="submit"
                      className="w-full sm:w-auto h-10 text-sm px-6"
                      onClick={() => handleGenerateReport()}
                    >
                      {loader ? (
                        <CircularProgress
                          size={28}
                          style={{ color: "white" }}
                        />
                      ) : (
                        <span className="d-flex flex-center">
                          <FileText className="w-4 h-4 mr-8" /> Generate Report
                        </span>
                      )}
                    </Button>
                  </div>
                </CardContent>
              </Card>
              {loader ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    Fetching report data...
                  </div>
                </Card>
              ) : employeeList?.length === 0 ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    No Records Found
                  </div>
                </Card>
              ) : (
                employeeList?.length > 0 && (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                    <CardHeader className="pb-16">
                      <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                        <div className="space-y-3 flex-1 min-w-0">
                          <div className="flex items-center space-x-2">
                            <MessageCircle className="h-5 w-5 mr-3" />
                            <CardTitle className="text-lg sm:text-xl">
                              Unread Messages Report Results
                            </CardTitle>
                          </div>
                          <CardDescription className="space-y-2">
                            <div className="font-medium text-sm sm:text-base">
                              {empName === "All"
                                ? "All Employees Report"
                                : `Employee Report for ${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`}
                            </div>
                            <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                            </div>
                          </CardDescription>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handelEmailFullReport()}
                            className="h-8"
                          >
                            <Mail className="mr-4 h-3 w-3" />
                            Email Report
                          </Button>
                          <Popover>
                            <PopoverTrigger asChild>
                              <Button
                                variant="outline"
                                size="sm"
                                className="h-8"
                              >
                                <Download className="mr-4 h-3 w-3" />
                                Download
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent className="w-40">
                              <div className="space-y-2">
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullPDF()}
                                >
                                  <FileText className="mr-8 h-3 w-3" />
                                  PDF
                                </Button>
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullExcel()}
                                >
                                  <FileSpreadsheet className="mr-8 h-3 w-3" />
                                  Excel
                                </Button>
                                <CSVLink
                                  data={clientsListCSV}
                                  filename={`CheckInCheckOutReport_${empName === "All"
                                      ? "All"
                                      : `${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                  asyncOnClick={true}
                                  onClick={(event, done) => {
                                    setDownloadFullCSVData(event, done);
                                  }}
                                  className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                >
                                  <FileSpreadsheet className="mr-16 h-4 w-4" />
                                  <span className="font-medium">CSV</span>
                                </CSVLink>
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="p-0 sm:p-6 sm:pt-0">
                      {!isMobile && (
                        <TooltipProvider>
                          <ThemeTable
                            rows={employeeList}
                            headCells={getColumns()}
                            hidePagination={true}
                            renderRowCell={renderRowCell}
                          />
                        </TooltipProvider>
                      )}
                      {isMobile && (
                        <MobileUnReadMessage
                          MobileViewData={MobileViewData}
                          handleEmailIconClick={handleEmailIconClick}
                          downloadForPDF={downloadForPDF}
                          downloadForExcel={downloadForExcel}
                          clientsListCSV={clientsListCSV}
                          setDownloadCSVData={setDownloadCSVData}
                          startDate={startDate}
                          endDate={endDate}
                          reportName={"UnreadMessagesReport"}
                        />
                      )}
                    </CardContent>
                  </Card>
                )
              )}
            </div>
          </div>
        </div>
        <EmailReports
          open={openEmailDialog}
          onClose={() => handleEmailDialogClose()}
        />
      </Container>
    </>
  );

}
export default UnReadMessage;